import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { alternatePath } from "@/lib/i18n";
import { breadcrumbJsonLd } from "@/lib/seo";
import { buildCorporateHead } from "@/lib/corporate-seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";
import { CorporatePricingDecisionPage } from "@/components/pricing/CorporatePricingDecisionPage";

export const Route = createFileRoute("/pricing")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildCorporateHead({
    locale: "en",
    title: "Shopify Project Pricing and Engineering Retainers | Shugert",
    description: "Start with a defined Shopify business constraint and an approved fixed-price scope. Continue with senior engineering capacity only when the work creates a justified roadmap.",
    path: "/pricing",
    altPath: alternatePath("/pricing", "es"),
    jsonLd: breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Pricing", path: "/pricing" }]),
  }),
  component: () => <SiteShell><CorporatePricingDecisionPage locale="en" /></SiteShell>,
});
